module.exports = __webpack_public_path__ + "static/4-1115f4539328bb94d8ab0b5007060c70.gif";